import { FieldProps } from "@/core/components/Field";
import { useGetPreviousAnswers } from "@/core/hooks/useGetPreviousAnswers/useGetPreviousAnswers";
import { useFlightResults } from "@/APR/hooks/useFlightResults/useFlightResults";
import { isISODateString, isISOTimeString } from "@/core/utils";
import DateTimeField from "../DateTimeField/DateTimeField";

const DefaultValueDateTimePicker = ({ field }: FieldProps) => {
  const { defaultValue } = field;

  const isISOTime: boolean = isISOTimeString(defaultValue ?? "");
  const variablesToRequest: string | undefined =
    !isISOTime && typeof defaultValue !== "undefined"
      ? `${defaultValue}`
      : undefined;

  if (!variablesToRequest) {
    throw new Error("Missing default input variable for datetime subtype.");
  }

  const { result }: any = useGetPreviousAnswers(variablesToRequest);
  const variableName: string =
    !isISOTime && defaultValue ? defaultValue : "departureDate";
  const departureDate: string = isISODateString(defaultValue ?? "")
    ? defaultValue
    : result[variableName];

  const { selectedFlightDate, setSelectedFlightDate } = useFlightResults({
    departureDate,
  });

  return (
    <>
      <DateTimeField
        field={field}
        initialValue={selectedFlightDate}
        onChange={setSelectedFlightDate}
      />
    </>
  );
};

export default DefaultValueDateTimePicker;
